import { showElement } from "@grindex-common/helpers/domManipulation";
import { $elementChild } from "@grindex-common/helpers/elements";
import { apiConfig } from "@grindex-common/helpers/apiConfig";
import { underscoreTemplateGrindex } from "@grindex-client/common/js/helpers/underscore-helper";

function init($views) {
	$views.forEach(($view) => {
		const apiUrl = $view.dataset.apiurl;
		const filter = $view.dataset.filter;
		const itemCount = $view.dataset.count;
		const facets = $view.dataset.facets;
		const fullUrl = "/" + apiConfig.apiLanguage + apiUrl;
		const query = {
			page: 0,
			pagesize: itemCount,
			filter: filter,
			facetids: facets ? facets.split(",") : [],
		};

		const $title = $view.querySelector(".title-wrapper");
		const $results = $elementChild($view, "item-list");
		const $noResults = $elementChild($view, "no-results");
		const $viewAllButton = $elementChild($view, "view-all");

		fetch(fullUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(query),
		})
			.then(
				function (response) {
					if (response.ok) {
						response.json().then(success.bind(this)).catch(error.bind(this));
					}
				}.bind(this),
			)
			.catch(error.bind(this));

		function success(result) {
			const totalItems = result.total;

			$results.innerHTML = "";
			showElement($title);

			if (totalItems > 0) {
				result.oldItems.forEach((item) => {
					const itemHtml = renderSingleResult(item);
					$results.innerHTML += itemHtml;
				});

				if (totalItems > itemCount) {
					showElement($viewAllButton);
				}
			} else {
				showElement($noResults);
			}
		}

		function error() {
			$results.innerHTML = "";
			showElement($title);
			showElement($noResults);
		}

		function renderSingleResult(item) {
			const template = underscoreTemplateGrindex(document.getElementById(`result-type-${item.Type}-tmpl`).innerHTML);
			return template({ ...item });
		}
	});
}

export default {
	view: "mostRecentBlock",
	init,
};
